import type { DetectionErrorCode, DetectionResponse } from '../models/ai-template-builder.model';

export type DetectionProblem = 'error' | 'empty' | 'rate_limited' | 'unreadable' | 'too_large' | 'forbidden';
export type DetectionState = 'pending' | 'resolved' | DetectionProblem;

export type DetectionOutcome = { response: DetectionResponse } | { httpStatus: number };

const HTTP_PROBLEMS: Partial<Record<number, DetectionProblem>> = {
  403: 'forbidden',
  422: 'unreadable',
  429: 'rate_limited',
};

const ERROR_CODE_PROBLEMS: Partial<Record<DetectionErrorCode, DetectionProblem>> = {
  document_unreadable: 'unreadable',
  document_too_large: 'too_large',
  forbidden: 'forbidden',
};

/**
 * Any other HTTP failure is an error, an expired run's 404 included: Try again starts a new run.
 * A resolved response without data has nothing to review, so it is empty.
 */
export function detectionState(outcome: DetectionOutcome): DetectionState {
  if ('httpStatus' in outcome) {
    return HTTP_PROBLEMS[outcome.httpStatus] ?? 'error';
  }

  const { status, errorCode, data } = outcome.response;

  if (status === 'error') {
    return (errorCode && ERROR_CODE_PROBLEMS[errorCode]) || 'error';
  }

  return status === 'resolved' && !data ? 'empty' : status;
}
